/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../core";
import { SheetId } from "../../../commons/types/SheetId";
export const CreateSnapshotRequest = core.serialization.object({
    sheetId: SheetId,
    label: core.serialization.string().optional(),
    threadId: core.serialization.string().optional(),
});
